import React from 'react';

import { WorkspaceLayout } from '../../shared/components/Layout';
import CalendarGrid from './components/CalendarGrid';
import Dialogs from './components/Dialogs';
import { CalendarProvider, DialogProvider, FilterProvider } from './context';

const Calendar = () => (
  <WorkspaceLayout>
    <CalendarProvider>
      <FilterProvider>
        <DialogProvider>
          <CalendarGrid />
          <Dialogs />
        </DialogProvider>
      </FilterProvider>
    </CalendarProvider>
  </WorkspaceLayout>
);

export default Calendar;
